var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button-burger",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"burger-menu",class:{'active': _vm.active}},_vm._l((3),function(line){return _c('span',{key:line,style:(_vm.burgerStyles)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }